module.exports = __webpack_public_path__ + "static/media/car_wash.ad0e81b6.png";